export default "__VITE_ASSET__82a830ee__"